import uniq from "lodash-es/uniq";
import { Reducer } from "redux";

import { tupdate } from "@/mk2/helpers/types";
import infiniteList, {
    State as InfiniteListState,
    initialState as infiniteInitialState,
} from "@/mk2/reducers/infiniteList";

import {
    LIST_OF_FORUMS_FETCH_FAILURE,
    LIST_OF_FORUMS_FETCH_REQUEST,
    LIST_OF_FORUMS_FETCH_SUCCESS,
    ListOfForumsFetchFailureAction,
    ListOfForumsFetchRequestAction,
    ListOfForumsFetchSuccessAction,
} from "./ListOfForums.actions";

export interface TopicsListState extends InfiniteListState {
    followingIds: number[];
}

type TopicsListReducerAction =
    | ListOfForumsFetchRequestAction
    | ListOfForumsFetchSuccessAction
    | ListOfForumsFetchFailureAction;

export const initialTopicsListState: TopicsListState = {
    ...infiniteInitialState,
    followingIds: [],
};

const topicsListReducer: Reducer<TopicsListState, TopicsListReducerAction> = (
    state = initialTopicsListState,
    action,
) => {
    const newState: TopicsListState = {
        ...state,
        ...infiniteList<
            ListOfForumsFetchRequestAction,
            ListOfForumsFetchSuccessAction,
            ListOfForumsFetchFailureAction
        >("LIST_OF_FORUMS_FETCH", (a) => a.response.result.topics)(state, action),
    };

    switch (action.type) {
        case LIST_OF_FORUMS_FETCH_SUCCESS:
            newState.followingIds = uniq(action.response.result.followingTopics);
            break;
    }

    return newState;
};

export interface ListOfForumsPageState {
    contestsTopicId: number | null;
    testingsTopicId: number | null;
    topics: TopicsListState;
}

export const initialListOfForumsPageState: ListOfForumsPageState = {
    contestsTopicId: null,
    testingsTopicId: null,
    topics: initialTopicsListState,
};

type ListOfForumsPageReducerAction =
    | ListOfForumsFetchRequestAction
    | ListOfForumsFetchSuccessAction
    | ListOfForumsFetchFailureAction;

const listOfForumsPageReducer: Reducer<ListOfForumsPageState, ListOfForumsPageReducerAction> = (
    state = initialListOfForumsPageState,
    action,
) => {
    switch (action.type) {
        case LIST_OF_FORUMS_FETCH_REQUEST:
        case LIST_OF_FORUMS_FETCH_FAILURE:
            return tupdate(state, {
                topics: topicsListReducer(state.topics, action),
            });

        case LIST_OF_FORUMS_FETCH_SUCCESS:
            return tupdate(state, {
                contestsTopicId: action.response.result.contestsTopic,
                testingsTopicId: action.response.result.testingsTopic,
                topics: topicsListReducer(state.topics, action),
            });

        default:
            return state;
    }
};

export default listOfForumsPageReducer;
